import { produce } from 'immer';
import { getFileTypeFromUntrustedExtension } from 'service/file';
import { eventAssetDataUpdated, eventLegacyFileUploaded } from 'store/actions';
import { SIGN_OUT } from 'store/auth/actions';
import { FilesContextEnum } from 'types/types';
import { createReducer } from 'typesafe-actions';
import { doFilesLoad } from './actions';
import { FilesState, RBFile } from './types';
import { FILE_TYPES } from 'service/file/types';

const initialState: FilesState = {
  context: undefined,
  files: [],
};

export const filesReducer = createReducer(initialState)
  .handleAction(SIGN_OUT.success, () => initialState)
  .handleAction(doFilesLoad, (state, action) => ({
    ...state,
    context: action.payload.context,
    files: action.payload.files,
  }))
  .handleAction(eventAssetDataUpdated, (state, action) =>
    produce(state, (draft) => {
      if (
        (state.context?.context === FilesContextEnum.localAsset &&
          state.context?.assetId === action.payload.assetId) ||
        (state.context?.context === FilesContextEnum.localAssessment &&
          state.context?.assetId === action.payload.assetId)
      ) {
        if (action.payload.updatedKeys.includes('files')) {
          draft.files = Object.values(action.payload.data.files).reduce<
            RBFile[]
          >((acc, file) => {
            const type = file?.type
              ? getFileTypeFromUntrustedExtension(file.type)
              : undefined;
            if (file && type) {
              acc.push({
                id: file.id,
                name: file.name,
                type,
                timestamp: file.timestamp,
                deletable: file.deletable,
                editable: file.editable,
              });
            }
            return acc;
          }, []);
        }
      }
    }),
  )

  .handleAction(eventLegacyFileUploaded, (state, action) =>
    produce(state, (draft) => {
      const context = draft.context;
      if (
        context?.context === FilesContextEnum.remoteAssessment &&
        context.assetId === action.payload.propertyId
      ) {
        draft.files = [
          ...state.files,
          ...Object.values(action.payload.filesSyncFormat).map<RBFile>(
            (file) => ({
              id: file.id,
              name: file.name,
              timestamp: file.timestamp,
              type:
                getFileTypeFromUntrustedExtension(file.type) || FILE_TYPES.jpeg,
              deletable: file.deletable,
              editable: file.editable,
            }),
          ),
        ];
      }
    }),
  );
